/* eslint-disable no-case-declarations */
import * as types from "./feeTypes";

const INITIAL_STATE = {
  listFee: [],
  patient: null,
  selectedFee: null,
  email: "",
  loading: false,
  hosNumber: "",
  listHistoryPayment: []
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.CHANGE_FEE_CODE: {
      return {
        ...state,
        hosNumber: action.hosNumber
      };
    }

    case types.SEARCH_FEE_CODE: {
      return {
        ...state,
        loading: true
      };
    }

    case types.SEARCH_FEE_CODE_SUCCESS: {
      return {
        ...state,
        listFee: action.payload,
        patient: { ...action.payload[0] },
        loading: false
      };
    }

    case types.SEARCH_FEE_CODE_ERROR: {
      return {
        loading: false
      };
    }

    case types.SELECT_FEE: {
      return {
        ...state,
        selectedFee: action.payload,
        email: action.payload.email
      };
    }

    case types.CLEAR_DATA_SEARCH_FEE_CODE: {
      return INITIAL_STATE;
    }

    case types.ON_CHANGE_EMAIL: {
      return {
        ...state,
        email: action.payload
      };
    }
    case types.REQUEST_PAYMENT_FEE: {
      return {
        ...state,
        loading: true
      };
    }
    case types.REQUEST_PAYMENT_FEE_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    case types.REQUEST_PAYMENT_FEE_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case types.GET_HISTORY_PAYMENT: {
      return {
        ...state,
        loading: true
      };
    }

    case types.GET_HISTORY_PAYMENT_SUCCESS: {
      return {
        ...state,
        listHistoryPayment: action.payload,
        loading: false
      };
    }

    case types.GET_HISTORY_PAYMENT_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    default:
      return state;
  }
};
